<template>
  <div style="margin: 15px 15px;">
    <div style="text-align:center">
      <el-image
        :src="productInfo.skuImg"
        fit="contain"
        :lazy="true"
        style="height: 300px; width: 300px"
      ></el-image>
    </div>
    <el-row :gutter="20">
      <span style="color: chocolate;"
        >您的身份信息在{{ productInfo.endTimeStr }}前有效</span
      >
      <h3>{{ productInfo.skuTitle }}</h3>
      <span
        >在售价：<span class="old-price">￥{{ productInfo.jdPrice }}</span></span
      >
      <span>￥{{ productInfo.trialPrice }}</span>
      <span>份数：</span>
      <span>{{ productInfo.supplyNum }}份</span>
      <el-tag v-if="productInfo.zyFlag == 1" type="success" size="mini"  effect="dark">自营</el-tag>
      
    </el-row>
    <div style="padding:5px">
      <el-button
      style="width: 100%;"
        type="primary"
        block
        @click="jump(productInfo.shortUrl)"
        >试用详情</el-button
      >
    </div>
  <div style="padding:5px">
      <el-button
      style="width: 100%;"
        @click="jump(productInfo.h5Url)"
        >H5详情</el-button
      >
  </div>
  <div style="padding:5px">
      <el-button
      style="width: 100%;"
        @click="jump(productInfo.webUrl)"
        >WEB详情</el-button
      >
      </div>
  <div style="padding:5px">
      <el-button
      style="width: 100%;"
        color="rgb(50, 221, 141)"
        @click="jump(productInfo.confirmUrl)"
        >复制跳转</el-button
      >
    </div>
    <div>
      <el-dialog
        title="登录"
        :visible.sync="loginDialogVisible"
        center
        :fullscreen="true"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <span>
          <el-form
            :model="loginForm"
            ref="loginForm"
            :rules="loginFormRules"
            label-width="80px"
            :inline="false"
          >
            <el-form-item label="QQ:" prop="qq">
              <el-input-number
                style="width: 90%"
                v-model="loginForm.qq"
                placeholder="请填写自己的QQ号"
                :controls="false"
              >
              </el-input-number>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input
                style="width: 90%"
                type="password"
                v-model="loginForm.password"
                autocomplete="off"
                placeholder="不是QQ密码！！！也不是京东密码！！！！"
              ></el-input>
            </el-form-item>
          </el-form>
        </span>
        <span slot="footer">
          <el-button type="primary" @click="submitLogin">登录</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from '@/plugins/axios'
import {login} from "@/api/jdUser";
export default {
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      btnLoading: false,
      isChecking: false,
      loginDialogVisible: false,
      loginForm: {
        qq: undefined,
        password: "",
      },
      loginFormRules: {
        qq: [
          {
            required: true,
            message: "此项必填",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "此项必填",
            trigger: "blur",
          },
        ],
      },
      currentUserInfo: {
        id: 19,
        qq: "111",
        nickname: "系统测试用户",
        isShowBrower: 0,
        applyNotFreeNum: 0,
        dailySignRes: "检查中...",
        adelceMilliseconds: 0,
        endTime: undefined,
        canOver: 0,
      },
      sort: 0,
      loginStatus: false,
      productInfo: {
        skuImg: undefined,
        skuTitle: undefined,
        trialPrice: undefined,
        jdPrice: undefined,
      },
      jdTrialProductTotal: 0,
      jdTrialProductList: [],
      dataListLoading: false,
    };
  },
  created() {
    this.getProductInfo();
  },
  mounted() {},
  methods: {
    jump(url) {
      if (url.indexOf("pay") > -1) {
        let oInput = document.createElement("input");
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select();
        document.execCommand("Copy");
        oInput.remove();
        this.$message.success("复制成功!");
      }
      location.href = url;
    },
    getProductInfo() {
      var productId = this.getQueryString("id");
      var localUserInfo = JSON.parse(localStorage.getItem("currentUserInfo"));
      if (localUserInfo != null && localUserInfo != undefined) {
        axios
          .get("/jdtrialproduct/getqywxindexproductinfo/" + productId, {
            headers: {
              token: localUserInfo.token,
            },
          })
          .then((res) => {
            if (res.code == 200 && res.data) {
              this.productInfo = res.data;
            } else {
                this.$message.warning("登录信息已失效");
                this.loginDialogVisible = true;
            }
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        this.loginDialogVisible = true;
      }
    },
    submitLogin() {
      this.$refs["loginForm"].validate((valid) => {
        if (valid) {
          login(this.loginForm).then((res) => {
              if (res.code == 200) {
                var data = res.data;
                if (data != null) {
                  this.$message.success("登录成功!");
                  this.currentUserInfo = data;
                  localStorage.setItem(
                    "currentUserInfo",
                    JSON.stringify(this.currentUserInfo)
                  );
                  this.loginDialogVisible = false;
                  this.getProductInfo();
                } else {
                  this.$message.warning(
                    "登录失败!请检查QQ或者密码是否匹配！注意不是密码QQ密码"
                  );
                }
              } else {
                this.$message.warning("登录失败!" + res.data.msg);
              }
            })
            .catch((e) => {
              this.$message.error("操作出错!" + e);
            });
        }
      });
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
      var context = "";
      if (r != null) context = decodeURIComponent(r[2]);
      reg = null;
      r = null;
      return context == null || context == "" || context == "undefined" ? "" : context;
    },
  },
};
</script>
<style>
.old-price {
  text-decoration: line-through;
  color: red;
}
</style>
